import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "src",
      description: "远程图片url",
      type: "String"
    },
    {
      prop: "localSrcPath",
      description: "本地图片",
      type: "Promise"
    },
    {
      prop: "defaultImage",
      description: "无图片无label时显示的默认图片",
      type: "String"
    },
    {
      prop: "lable",
      description: "无图片时显示label首字母",
      type: "String"
    },
    {
      prop: "fontSize",
      description: "显示字母的字体大小",
      type: "String",
      default: "14px"
    },
    {
      prop: "randomColors",
      description: "显示字母的背景色组",
      type: "Array",
      default: `["#ff6d3f", "#3fb6e8", "#89af33", "#ffc12c"]`
    },
    {
      prop: "round",
      description: "是否为圆形",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "imageStyle",
      description: "图片样式",
      type: "Object",
      default: "{width: 100%,height: 100%}"
    },
    {
      prop: "cacheColor",
      description: "是否缓存label对应的色值",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
